import { getItem, LS_KEYS, removeItem, setItem } from 'utils/localStorage';

import { UserAuth } from './interfaces';

const AUTH_DEFAULT = {
  access_token: '',
  access_token_ttl: 0,
  refresh_token: '',
  refresh_token_ttl: 0,
  user_id: '',
};

const setUserAuthLS = (user: UserAuth) => {
  setItem(LS_KEYS.auth, JSON.stringify(user));
};

const getUserAuthLS = (): UserAuth => {
  const auth = JSON.parse(getItem(LS_KEYS.auth) || '{}');
  return auth;
};

const getAccessTokenLS = () => {
  const auth = getUserAuthLS();
  return auth.access_token;
};

const getAccessTokenTTL = () => {
  const auth = getUserAuthLS();
  return auth.access_token_ttl;
};

const setAccessTokenLS = (accessToken: string) => {
  const auth = getUserAuthLS();
  auth.access_token = accessToken;
  return setUserAuthLS(auth);
};

const getRefreshTokenLS = () => {
  const auth = getUserAuthLS();
  return auth.refresh_token;
};

const getRefreshTokenTTL = () => {
  const auth = getUserAuthLS();
  return auth.refresh_token_ttl;
};

const setRefreshTokenLS = (refreshToken: string) => {
  const auth = getUserAuthLS();
  auth.refresh_token = refreshToken;
  return setUserAuthLS(auth);
};

const resetUserAuthLS = () => {
  setUserAuthLS(AUTH_DEFAULT);
};

const removeUserAuthLS = () => {
  removeItem(LS_KEYS.auth);
};

const TokenService = {
  getAccessTokenLS,
  getAccessTokenTTL,
  getRefreshTokenLS,
  getRefreshTokenTTL,
  getUserAuthLS,
  removeUserAuthLS,
  resetUserAuthLS,
  setAccessTokenLS,
  setRefreshTokenLS,
  setUserAuthLS,
};

export default TokenService;
